
import { useState, useEffect, useCallback } from "react";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import { Button, Box, Stack, Card, Typography, IconButton, Grid, Container, Tooltip, CircularProgress, useTheme, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useSettingsContext } from 'src/components/settings/index.js';
import { useBoolean } from '../../../hooks/use-boolean.js';
import { FormBuilderDialog } from '../../../components/form-builder/index.js';
import { useSnackbar } from 'src/components/snackbar/index.js';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/index.js';
import Iconify from 'src/components/iconify/iconify.js';
import { formCategory_All } from "src/util/formCategory.js";

// GRAPHQL
import { CREATE_CUSTOMFORM, UPDATE_CUSTOMFORM, GET_CUSTOMFORM } from "src/graphql/modules/_client/customForm.js";
import { useMutation, useQuery } from "@apollo/react-hooks";



export default function FormBuilder() {
  const settings = useSettingsContext();
  const {fullName} = useSelector((state) => state?.auth?.user);
  const theme = useTheme();
  const navigate = useNavigate();
  const company_name  = useSelector((state) => state?.auth?.companyProfile?.companyProfile?.databaseName);
  const _companyName  = useSelector((state) => state?.auth?.companyProfile?.companyProfile?.companyName);
  const [formFields, setFormFields] = useState([]);
  const [results, setResults] = useState(null);
  const [formTitle, setFormTitle] = useState("");
  const [orientation, setOrientation] = useState(false);
  const [category, setCategory] = useState("Section A");
  const [filterCategory, setFilterCategory] = useState("All");
  const [formId, setFormId] = useState("");
  const confirm = useBoolean();

  const { enqueueSnackbar } = useSnackbar();
  const [CreateCustomFormMutation] =  useMutation(CREATE_CUSTOMFORM);
  const [UpdateCustomFormMutation] =  useMutation(UPDATE_CUSTOMFORM);
  

  const { data, refetch } = useQuery(GET_CUSTOMFORM, {
    variables: {
      companyName: company_name,
      encryptionkey: "",
      filterCategory: filterCategory
      },
      fetchPolicy: "cache-and-network",
    });

 

    useEffect(() => {
        if(data){
          setResults(data?.getCustomForm)
        }
    }, [data, filterCategory])

  const handleSave = async() => {
    try {
      if(formTitle.length === 0){
        enqueueSnackbar('Form title is required.', {variant: 'error'});
      }else {
      const firstWord = formTitle.split(" ")[0];
      const rand = _.random(0, 99);
      const {data: { createCustomForm }} = await CreateCustomFormMutation({
        variables: {
          companyName: company_name,
          fullName: fullName,
          encryptionkey: "",
            data: {
              title:  formTitle,
              description: "This is custom form.",
              formModel: `newForm_${firstWord}_${rand}`,
              category: category,
              orientation: orientation,
              section: formFields,
              createdBy: fullName,
              createdDate: new Date(),
              modifiedBy: fullName,
              modifiedDate: new Date()
            }
          }
      })
      if(createCustomForm?.success){
        enqueueSnackbar('Create success!', {variant: 'success'});
        refetch();
      }else {
        enqueueSnackbar('Failed to created', {variant: 'error'});
      }
      }

    } catch(err){
      console.log(err)
    }
  }

  const handleUpdate = async() => {
    try {
      const {data: { updateCustomForm }} = await UpdateCustomFormMutation({
        variables: {
          _id: formId,
          companyName: company_name,
          fullName: fullName,
          encryptionkey: "",
            data: {
              title:  formTitle,
              description: "This is custom form.",
              category: category,
              orientation: orientation,
              section: formFields,
              modifiedBy: fullName,
              modifiedDate: new Date()
            }
          }
      })
      if(updateCustomForm?.success){
        enqueueSnackbar('Update success!', {variant: 'success'});
        refetch();
      }else {
        enqueueSnackbar('Failed to update', {variant: 'error'});
      }

    } catch(err){
      console.log(err)
    }
  }

  const handleChangeTitle = (event) => {
    const {value} = event.target;
    setFormTitle(value)
  }

  const navigateToForm = useCallback((data) => {
      navigate(`/${company_name}/auditing/${data?._id}`, {state: {data}})
  });

    const handleChangeCategory = (event) => {
       const {value} = event.target;
      setCategory(value)
  }

  const handleFilterCategory = (event) => {
       const {value} = event.target;
      setFilterCategory(value)
  }

  const handleOrientation = (event) => {
       const {checked} = event.target;
      setOrientation(checked)
  }

  


  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
                 <CustomBreadcrumbs
                 heading={`${_companyName} - Auditing Form`}
                 links={[
                  {name: 'Dashboard'},
                  {name: 'Auditing'}
                 ]}
                 action={
                  <Button onClick={() => confirm.onTrue()}
                   variant="contained"
                    startIcon={<Iconify icon="mingcure:add-line" />}
                  >Forms</Button>
                 }
                />

                  <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1, mb: 1}} >
                      <FormControl sx={{width: 350, mb: 3}}>
                                    <InputLabel id="select-category">Filter Category</InputLabel>
                                    <Select
                                      labelId="select-label-category"
                                      id="select-category"
                                      label="Filter Category"
                                      size='small'
                                      onChange={handleFilterCategory}
                                      name='selectCategory'
                                      value={filterCategory}
                                    > 
                                      {formCategory_All?.map((res) => {
                                        return(
                                          <MenuItem value={res?.value}>{res?.label}</MenuItem>
                                        )
                                      })}
                                    </Select>
                     </FormControl>
                  </Stack>

                  <Grid container spacing={2}>
                    {
                      results?.results?.map((res, index) => {
                        return(
                          <Grid item sm={12} md={4}>
                          <Card sx={{ display: 'flex', alignItems: 'center', p: 3}}>
                          <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="title1">{res?.title}</Typography>
                            <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1 }}>
                            </Stack>
                            </Box>
                            <Stack alignItems="center" justifyContent="center" sx={{ position: 'relative' }}>
                            <Tooltip title={res?.title}>
                            <IconButton onClick={() => navigateToForm(res)}>
                              <Iconify icon={'fluent:form-20-regular'} width={32} sx={{ color: theme.palette.info.main, position: 'absolute' }} />
                                <CircularProgress
                                  variant="determinate"
                                  value={100}
                                  size={56}
                                  thickness={2}
                                  sx={{ color: theme.palette.info.main, opacity: 0.48 }}
                                />
                            </IconButton>
                            </Tooltip>
                            </Stack>
                      </Card>
                      </Grid>
                        )
                      })
                    }

                </Grid>

           <FormBuilderDialog
              open={confirm.value}
               onClose={confirm.onFalse}
              title="Create Auditing Form"
              content={`Are you sure want to delete?`}
              setFormFields={setFormFields}
              formFields={formFields}
              customForms={results}
              formTitle={formTitle}
              handleChangeTitle={handleChangeTitle}
              setFormTitle={setFormTitle}
              setCategory={setCategory}
              refetchQuery={refetch}
              setFormId={setFormId}
              orientation={orientation}
              setOrientation={setOrientation}
              handleOrientation={handleOrientation}
              category={category}
              handleChangeCategory={handleChangeCategory}
               action={
                <Button variant="contained" color="info" onClick={handleSave} >
                  Save
               </Button>
             }
             actionUpdate={
              <Button variant="contained" color="info" onClick={handleUpdate} >
                 Update
            </Button>
             }
            />
      </Container>
  );
}
